import { Form } from "react-bootstrap";
import styles from "./styles.module.scss";

export default function Knn(props) {
  const { rootNodePath, execute, handleChange } = props;

  return (
    <div className={styles.randomBox}>
      <div className={styles.select}>
        <div className={styles.label}>Neighborhoods</div>
        <div className={styles.content}>
          <Form.Control
            type="number"
            min={0}
            max={10000}
            value={execute.k || 10}
            onChange={(e) => handleChange("k", e)}
            name={`${rootNodePath}execute.otherFields.k`}
            id={`${rootNodePath}execute.otherFields.k`}
          />
        </div>
      </div>
    </div>
  );
}
